const listText = [
  {
    id: "mail",
    texts: {
      text_1: {
        id: "t1",
        mainText: "Te enviamos un código de 4 dígitos al correo:",
      },
      text_2: {
        id: "t2",
        mainText: "Cambiar correo electrónico",
      },
      text_3: {
        id: "t3",
        mainText: "Continuar",
      },
    },
  },
  {
    id: "phone",
    texts: {
      text_1: {
        id: "t1",
        mainText: "Te enviamos un código de 4 dígitos al número:",
      },
      text_2: {
        id: "t2",
        mainText: "Cambiar número",
      },
      text_3: {
        id: "t3",
        mainText: "Continuar",
      },
    },
  },
];

const objListText = {
  text_1: {
    id: "t1",
    mainText: "¡Ups lo sentimos!",
  },
  text_2: {
    id: "t2",
    mainText: "Reintentar",
  },
  text_3: {
    id: "t3",
    mainText:
      "La aplicación no esta respondiendo debido a que hay problemas con la comunicación de nuestros sistemas.",
  },
  text_4: {
    id: "t4",
    mainText: "Vuelve a intentar si el error persiste.",
  }
};

export {
  listText,
  objListText
}
